import { Link } from "react-router-dom";
import { Box, Typography, Button, Divider } from '@mui/material';
import Navbar from '../Layouts/Navbar';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import { Edit } from '@mui/icons-material';

export default function ReservationDetail() {
  const data = {
    date: '22/03/2025',
    direction: 'Nord',
    trajet: 'Ville A - Ville B',
    pickup: 'Adresse A',
    dropoff: 'Adresse B',
    heure: '14:00',
  };

  return (
    <>
      <Navbar />
      <Box p={3}>
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
          <Box display="flex" alignItems="center">
            <AccessTimeIcon />
            <Typography variant="h6" ml={1}>RÉSERVATIONS</Typography>
          </Box>
          <Box display="flex" gap={2}>
            <Button
            component={Link}        
            to="/reservation"
              variant="outlined"
              sx={{
                color: 'red',
                borderColor: 'red',
                textTransform: 'none',
                '&:hover': { backgroundColor: 'red', color: '#fff', borderColor: 'red' },
              }}
              startIcon={<AccessTimeIcon />}
            >
              Liste des réservations
            </Button>
            <Button
            component={Link}
              to="/edit-reservation"
              variant="outlined"
              sx={{
                color: 'red',
                borderColor: 'red',
                textTransform: 'none',
                '&:hover': { backgroundColor: 'red', color: '#fff', borderColor: 'red' },
              }}
              startIcon={<Edit />}
            >
              Modifier
            </Button>
          </Box>
        </Box>

        {/* Data Section */}
        <Box flex={1} pr={2}>
          {[
            { label: 'Date', value: data.date },
            { label: 'Direction', value: data.direction },
            { label: 'Nom du trajet', value: data.trajet },
            { label: 'Pick-Up', value: data.pickup },
            { label: 'Drop-Off', value: data.dropoff },
            { label: 'Heure', value: data.heure },
          ].map((item, index) => (
            <Box key={index}>
              <Box display="flex" justifyContent="space-between" py={1}>
                <Typography>{item.label}</Typography>
                <Typography textAlign="center" flex={1}>{item.value}</Typography>
              </Box>
              <Divider />
            </Box>
          ))}
        </Box>
      </Box>
    </>
  );
}
